// removed by extract-text-webpack-plugin
module.exports = {"section":"src-pages-services----erpnext-module---section---1w3KH","content":"src-pages-services----erpnext-module---content---1rxQy","smallCaps":"src-pages-services----erpnext-module---smallCaps---TPves","pointers":"src-pages-services----erpnext-module---pointers---3bhuE","icon":"src-pages-services----erpnext-module---icon---3OWUr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/services/erpnext.module.scss
// module id = 570
// module chunks = 94916293918715